var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxIconTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6789 0.171781C11.9518 0.421302 11.9764 0.851141 11.7338 1.13185L4.68148 9.29241C4.55602 9.43759 4.37618 9.52066 4.18733 9.52066C3.99848 9.52066 3.81864 9.43759 3.69318 9.29241L0.167009 5.21213C-0.0755811 4.93142 -0.0509989 4.50158 0.221915 4.25206C0.494829 4.00254 0.912727 4.02782 1.15532 4.30854L4.18733 7.81701L10.7455 0.228256C10.9881 -0.052456 11.406 -0.0777406 11.6789 0.171781Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxIconTick);
export default __webpack_public_path__ + "static/media/checkbox-icon-tick.a92963a5.svg";
export { ForwardRef as ReactComponent };